import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sparkles, X } from "lucide-react";

export default function UsageNudge() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const month = user?.usage?.month || "";
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(`gs_nudge_${month}`) === "1");

  if (dismissed || !["creator", "growth", "agency", "pro"].includes(user?.plan)) return null;

  const posts = user?.usage?.ai_posts ?? 0;
  const postCap = user?.limits?.ai_posts;
  const images = user?.usage?.images ?? 0;
  const imgCap = user?.limits?.images_month;

  const postNear = typeof postCap === "number" && postCap > 0 && posts / postCap >= 0.8;
  const imgNear = typeof imgCap === "number" && imgCap > 0 && images / imgCap >= 0.8;
  if (!postNear && !imgNear) return null;

  const msg = postNear
    ? `You've used ${posts}/${postCap} AI posts this month.`
    : `You've used ${images}/${imgCap} graphics this month.`;

  const dismiss = () => {
    localStorage.setItem(`gs_nudge_${month}`, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="usage-nudge" className="mb-6 flex items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3">
      <Sparkles className="h-4 w-4 text-amber-400 shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <span className="text-foreground">{msg}</span>{" "}
        <span className="text-muted-foreground">Upgrade for unlimited posts and graphics.</span>
      </div>
      <Button data-testid="usage-nudge-upgrade" size="sm" onClick={() => navigate("/billing")}
        className="bg-amber-500 hover:bg-amber-500/90 text-black shrink-0 h-8">
        Upgrade
      </Button>
      <button data-testid="usage-nudge-dismiss" onClick={dismiss} className="text-muted-foreground hover:text-foreground shrink-0">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
